import { gql } from '@apollo/client';

export const EXECUTE_TEXT_PROMPT = gql`
  query ExecuteTextPrompt(
    $prompt: NonEmptyTrimmedString!
    $model: String
    $max_completion_tokens: UnsignedInt
    $temperature: UnsignedFloat
    $top_p: UnsignedFloat
    $frequency_penalty: Float
    $presence_penalty: Float
    $response_format: JSONObject
  ) {
    executeTextPrompt(
      prompt: $prompt
      model: $model
      max_completion_tokens: $max_completion_tokens
      temperature: $temperature
      top_p: $top_p
      frequency_penalty: $frequency_penalty
      presence_penalty: $presence_penalty
      response_format: $response_format
    ) {
      content
    }
  }
`;
